/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Multicall2, Multicall2Interface } from "../Multicall2";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "target",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
        ],
        internalType: "struct Multicall2.Call[]",
        name: "calls",
        type: "tuple[]",
      },
    ],
    name: "aggregate",
    outputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
      {
        internalType: "bytes[]",
        name: "returnData",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "target",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
        ],
        internalType: "struct Multicall2.Call[]",
        name: "calls",
        type: "tuple[]",
      },
    ],
    name: "blockAndAggregate",
    outputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "blockHash",
        type: "bytes32",
      },
      {
        components: [
          {
            internalType: "bool",
            name: "success",
            type: "bool",
          },
          {
            internalType: "bytes",
            name: "returnData",
            type: "bytes",
          },
        ],
        internalType: "struct Multicall2.Result[]",
        name: "returnData",
        type: "tuple[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
    ],
    name: "getBlockHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "blockHash",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getBlockNumber",
    outputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCurrentBlockCoinbase",
    outputs: [
      {
        internalType: "address",
        name: "coinbase",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCurrentBlockDifficulty",
    outputs: [
      {
        internalType: "uint256",
        name: "difficulty",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCurrentBlockGasLimit",
    outputs: [
      {
        internalType: "uint256",
        name: "gaslimit",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCurrentBlockTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "getEthBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getLastBlockHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "blockHash",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "requireSuccess",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "address",
            name: "target",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
        ],
        internalType: "struct Multicall2.Call[]",
        name: "calls",
        type: "tuple[]",
      },
    ],
    name: "tryAggregate",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "success",
            type: "bool",
          },
          {
            internalType: "bytes",
            name: "returnData",
            type: "bytes",
          },
        ],
        internalType: "struct Multicall2.Result[]",
        name: "returnData",
        type: "tuple[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "requireSuccess",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "address",
            name: "target",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
        ],
        internalType: "struct Multicall2.Call[]",
        name: "calls",
        type: "tuple[]",
      },
    ],
    name: "tryBlockAndAggregate",
    outputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "blockHash",
        type: "bytes32",
      },
      {
        components: [
          {
            internalType: "bool",
            name: "success",
            type: "bool",
          },
          {
            internalType: "bytes",
            name: "returnData",
            type: "bytes",
          },
        ],
        internalType: "struct Multicall2.Result[]",
        name: "returnData",
        type: "tuple[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class Multicall2__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Multicall2> {
    return super.deploy(overrides || {}) as Promise<Multicall2>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Multicall2 {
    return super.attach(address) as Multicall2;
  }
  connect(signer: Signer): Multicall2__factory {
    return super.connect(signer) as Multicall2__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): Multicall2Interface {
    return new utils.Interface(_abi) as Multicall2Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Multicall2 {
    return new Contract(address, _abi, signerOrProvider) as Multicall2;
  }
}
